export function getExchangeColumn(country, exchange) {
	return `<td style="animation-delay: 0.3s;">
                <div class="info v2-flexbox v2-align--middle v2-pal5">
                <div class="instrument__logo exchange__logo v2-flag" style="background-image:url('/Content/assets/flags/inspiration/${country}.svg')"></div>
                    <span>${exchange}</span>
                </div>
            </td>`;
}

export function getInstrumentColumn(instrument) {
	const {
		Name,
		Icon,
		Currency,
		HideCountry,
		HideCurrency,
		Country,
		HasAssetIcon,
		HideSubtitleText
	} = instrument;
	const Exchange = instrument.Symbol || '';
	return `<td style="animation-delay: 0.3s;">
                <div class="instrument">
                  ${
										HasAssetIcon
											? `<div class="instrument__logo instrument__logo--${Icon}"></div>`
											: `
                  <div class="instrument__logo v2-flag" style="background-image:url('/Content/assets/flags/inspiration/${Country}.svg')"></div>
                  `
									}
                    
                    <div class="instrument__description">
                        <div class="instrument__description-name">${Name}</div>	
                        
                        <div class="instrument__description-exchange">
                        ${!HideSubtitleText ? `<span>${Exchange}</span>` : ''}
                        ${!HideCurrency && !HideSubtitleText ? `<sup>.</sup>` : ''}
                        ${!HideCurrency ? `<span>${Currency}</span>` : ''}
                        ${
													!HideCountry
														? `<span class="v2-flag" style="background-image:url('/Content/assets/flags/inspiration/${Country}.svg')"></span>`
														: ''
												}								
                        </div>	
                        
                    

                    </div>
                </div>
            </td>`;
}
export function getPricingColumn(pricingPlans) {
	return pricingPlans
		.map(column => {
			return `
        <td style="animation-delay: 0.3s;">
            <div class="v2-flexbox v2-align--top v2-direction--column plans">
            ${
							column.HasMultilineFormatting
								? column.Value
								: `<span class="v2-text--bold cell-text"> ${column.Value} </span>`
						}
        
            ${column.SubValue && `<span>${column.SubValue}</span>`}
            </div>			
        </td>	
        `;
		})
		.join('');
}

export function getInfoColumn(context, info) {
	if (!context.showInfoCol || info.Hide) return '';
	const infoUrl = !context.config.servicedomain
		? info.Url
		: context.config.servicedomain + info.Url;
	return `<td style="animation-delay: 0.3s;">
                <div class="info v2-flexbox v2-align--middle v2-pal5">
                <span role="button" data-qa="info-icon" data-url=${infoUrl} data-target="instrument-popup" aria-label="${context.config.params.infoLabel}" class="detail-icon v2-mar20"> 
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7.4" stroke="#1B73EE" stroke-width="1.2"/>
                    <path d="M7.23797 11.7481V6.29351H8.75075V11.7481H7.23797ZM8.00146 5.59038C7.77656 5.59038 7.58361 5.51581 7.42263 5.36666C7.26164 5.21515 7.18115 5.03404 7.18115 4.82334C7.18115 4.61501 7.26164 4.43627 7.42263 4.28712C7.58361 4.1356 7.77538 4.05984 7.99791 4.05984C8.22519 4.05984 8.41813 4.1356 8.57675 4.28712C8.73773 4.43627 8.81823 4.61501 8.81823 4.82334C8.81823 5.03404 8.73773 5.21515 8.57675 5.36666C8.41813 5.51581 8.22637 5.59038 8.00146 5.59038Z" fill="#1B73EE"/>
                    </svg>					
                </span>
                </div>
            </td>`;
}

export function getTradeColumn(context, assetName, uic) {
	if (!context.tradeCol) return '';
	let template = context.tradeCol.querySelector('template').innerHTML;
	template = template.match(/href="/)
		? template.replace(/{assetName}/, assetName).replace(/{uic}/, uic)
		: template;
	return `
    <td class="trade-button__container" style="animation-delay: 0.3s;">
       ${template}
    </td>
    `;
}

export function getInstrumentHeader(context, instrument, index, startIndex, loadMore = false) {
	const {
		Name,
		Icon,
		Currency,
		HideCountry,
		HideCurrency,
		Country,
		HasAssetIcon,
		HideSubtitleText
	} = instrument;

	const Exchange = instrument.Symbol || '';
	const id = `${context.dom.dpContainer.dataset.guid}_cb-${index}_${new Date().getTime()}`;
	return `<input type="checkbox" id="expand_${id}" ${
		(index === 0 || startIndex === 0) && !loadMore ? 'checked' : ''
	}>
            <label for="expand_${id}" class="table-content">
                <div class="instrument first" style="animation-delay: 0.2s;">
                  ${
										HasAssetIcon
											? `<div class="instrument__logo instrument__logo--${Icon}"></div>`
											: `<div class="instrument__logo v2-flag" style="background-image:url('/Content/assets/flags/inspiration/${Country}.svg')"></div>`
									}
                    </span><div class="instrument__description">
                    <div class="instrument__description-name">${Name}</div>

            
                    <div class="instrument__description-exchange">
                    ${!HideSubtitleText ? `<span>${Exchange}</span>` : ''}
                    ${!HideCurrency && !HideSubtitleText ? `<sup>.</sup>` : ''}
                    ${!HideCurrency ? `<span>${Currency}</span>` : ''}
                    ${
											!HideCountry
												? `<span class="v2-flag" style="background-image:url('/Content/assets/flags/inspiration/${Country}.svg')"></span>`
												: ''
										}								
                    </div>							
                        
                    </div>
                </div>
                <div class="last"><div class="toggle"></div></div>
            </label>		
    `;
}

export function getInstrumentDetails(
	context,
	pricingPlans,
	info,
	country,
	exchange,
	assetName,
	uic
) {
	let exchangeStr = '';
	let tradeColTemplate = context.tradeCol?.querySelector('template').innerHTML || '';
	tradeColTemplate = tradeColTemplate.match(/href="/)
		? tradeColTemplate.replace(/{assetName}/, assetName).replace(/{uic}/, uic)
		: tradeColTemplate;
	const infoUrl = !context.config.servicedomain
		? info.Url
		: context.config.servicedomain + info.Url;

	if (context.isETFTable && context.isExchangeColumn) {
		exchangeStr = `<div class="expanded-table">
            <div class="v2-text-align--left v2-text--bold expanded-table__column-left v2-flexbox v2-align--middle">Exchange</div>
            <div class="v2-text-align--right expanded-table__column-right">
            <div class="instrument__logo v2-flag" style="background-image:url('/Content/assets/flags/inspiration/${country}.svg')"></div>
            ${exchange}</div>
        </div>`;
	}
	/* eslint-disable indent */
	/* eslint-disable prettier/prettier */
    return `<div class="info v2-bg--white">		
                <div class="info-content" style="animation-delay: 0.1s;">
                  ${exchangeStr}
                  ${pricingPlans.map((item) =>
                    `<div class="expanded-table">
                        
                        <div class="v2-text-align--left v2-text--bold expanded-table__column-left v2-flexbox v2-align--middle">
                        ${item.ShowInfo === true ? `
                        <span role="button" class="dynamic-pricing__headerIcon" data-template-id="headerInfo-${item.Name.trim()}">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="8" r="7.4" stroke="#1B73EE" stroke-width="1.2"></circle>
                            <path d="M7.23797 11.7481V6.29351H8.75075V11.7481H7.23797ZM8.00146 5.59038C7.77656 5.59038 7.58361 5.51581 7.42263 5.36666C7.26164 5.21515 7.18115 5.03404 7.18115 4.82334C7.18115 4.61501 7.26164 4.43627 7.42263 4.28712C7.58361 4.1356 7.77538 4.05984 7.99791 4.05984C8.22519 4.05984 8.41813 4.1356 8.57675 4.28712C8.73773 4.43627 8.81823 4.61501 8.81823 4.82334C8.81823 5.03404 8.73773 5.21515 8.57675 5.36666C8.41813 5.51581 8.22637 5.59038 8.00146 5.59038Z" fill="#1B73EE"></path>
                            </svg>
                        </span>`: ''
                        }
                        ${item.Label}
                    
                        </div>
                        <div class="v2-text-align--right expanded-table__column-right">
                           <span class=${item.HasMultilineFormatting ? 'multiValues': 'v2-text--bold'}> ${item.Value}</span>
                              ${item.SubValue && `<span>${item.SubValue}</span>` }
                        </div>
                    </div>`
                ).join('')}	

                <div class="action-column action-column--left">
                    ${ !info.Hide && context.showInfoCol ?
                    `<span data-url="${infoUrl}" data-qa="info-icon"  data-target="instrument-popup">
                        <span class="detail-text">${context.config.params.infoMobiletext ? context.config.params.infoMobiletext : 'More details2'}</span> 
                    </span>` : 
                    '<span style="display:inline-block"></span>'	}
                </div>					

                <div class="trade-button__container action-column action-column--right">
                      ${context.tradeCol ? tradeColTemplate : ''}						
                </div>				
                </div>
            </div>`
    
    ;
}

export function getErrorTemplate(context, title, msg) {
    const ele = context.dom.errorstate;
    const txt = ele.innerHTML;
    return txt.replace(/%-errorTitle-%/, title).replace(/%-errorMsg-%/, msg);
}

export function getNoresultsTemplate(context) {
    const ele = context.dom.noresult;
    const txt = ele.innerHTML;
    const regEx = /%-name-%/g;
    return txt.replace(regEx, context.query.current);
}

export function checkAndRenderForNoResult(context,data,loadMore, desktopFrag, mobileFrag) {
    if (data.length === 0 && loadMore === false) {
        const noResultsMarkup = getNoresultsTemplate(context);
        const mobileRow = document.createElement('div');
        mobileRow.innerHTML = noResultsMarkup;

        const row = document.createElement('tr');
        const col = document.createElement('td');
        col.colSpan = 15;
        col.innerHTML = noResultsMarkup;
        row.appendChild(col);

        desktopFrag.appendChild(row);
        mobileFrag.appendChild(mobileRow);
        return true;
    }
    return false;
}

function setTradeColumnUniqueId(row) {
    const tradeButtonSelector = '.trade-button__container';
    const tradeButton = row.querySelector(`${tradeButtonSelector} #tradebutton_`);
    if (!tradeButton) return;

    const randomId = crypto.randomUUID();
    tradeButton.setAttribute('id', 'tradebutton_' + randomId);
    
    const targetId = tradeButton.getAttribute('data-target');
    if (targetId) {
        const updatedTargetId = targetId + randomId;
        tradeButton.setAttribute('data-target', updatedTargetId);
        row.querySelector(`${tradeButtonSelector} [id="${targetId}"]`).setAttribute('id', updatedTargetId);
    }
}

export function prepareContentForTable(
	context,
	item,
	index,
	startIndex,
	loadMore,
	desktopFrag,
	mobileFrag
) {
	let exchangeColumn = '';
	const row = document.createElement('tr');
	const instrumentSection = getInstrumentColumn(item?.Instrument);
    const assetName = item?.Instrument?.AssetName;
    const uic = item?.Instrument?.Uic;
	if (context.isETFTable && context.isExchangeColumn) {
		exchangeColumn = getExchangeColumn(item?.Instrument?.Country, item?.Instrument?.Exchange);
	}
	const pricingPlans = getPricingColumn(item.PricingPlans);
	const infoColumn = getInfoColumn(context, item.Info);
	const tradeColumn = getTradeColumn(context, item?.Instrument?.AssetName, item?.Instrument?.Uic);
    row.setAttribute('data-asset-name', assetName);
    row.setAttribute('data-uic', uic);
	row.innerHTML = [instrumentSection, exchangeColumn, pricingPlans, infoColumn, tradeColumn].join(
		''
	);
    setTradeColumnUniqueId(row);

	desktopFrag.appendChild(row);

	// mobile markup
	const mobileRow = document.createElement('div');
	mobileRow.classList.add('dynamic-pricing__row');
	const instrumentHeader = getInstrumentHeader(
		context,
		item.Instrument,
		index,
		startIndex,
		loadMore
	);
	const instrumentDetails = getInstrumentDetails(
		context,
		item.PricingPlans,
		item.Info,
		item.Instrument.Country,
		item.Instrument.Exchange,
        assetName, uic
	);
    mobileRow.setAttribute('data-asset-name', assetName);
    mobileRow.setAttribute('data-uic', uic);
	mobileRow.innerHTML = [instrumentHeader, instrumentDetails].join('');
    setTradeColumnUniqueId(mobileRow);
	mobileFrag.appendChild(mobileRow);
}